import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SelectionStateManagerV2.html?raw';
import "../../../moreCore/UI/SelectBox/SelectBox";
import "../../../moreCore/UI/Button/Button";

import "../OrchestraMatrixWsyTypes";


class StackEntry {
    Entity: OrchestraMatrixWsy_DataItem_Content;
    action: "create" | "delete" | "update";
}

class SelectionStateManagerV2 extends compose(_WidgetBaseSP) {
    templateString: any = template;

    stack: Array<StackEntry> = new Array<StackEntry>();

    itemsToDelete: Array<OrchestraMatrixWsy_DataItem_Content> = new Array<OrchestraMatrixWsy_DataItem_Content>();
    itemsToCreate: Array<OrchestraMatrixWsy_DataItem_Content> = new Array<OrchestraMatrixWsy_DataItem_Content>();
    itemsToUpdate: Array<OrchestraMatrixWsy_DataItem_Content> = new Array<OrchestraMatrixWsy_DataItem_Content>();

    // Anmerkungsspalte: staged im Host (OrchestraMatrixWsy._dirtyNotes). Nur ein Flag, damit die
    // Buttons auch bei reinen Anmerkungs-Aenderungen aktiv werden. Gespeichert wird im Host (CommitRowNotes).
    notesDirty: boolean = false;

    deletedNode: HTMLDivElement;
    createdNode: HTMLDivElement;
    btnCommit: HTMLButtonElement;
    btnRollback: HTMLButtonElement;

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.displayStack();
    }

    displayStack(): void {
        this._calculateStackEntityActions();

        this.UiModder.domAttr.set(this.deletedNode, "innerHTML", this.itemsToDelete.length + this.getTranslation("OM_Matrix__lbl_ItemsDeleted"));
        this.UiModder.domAttr.set(this.createdNode, "innerHTML", this.itemsToCreate.length + this.getTranslation("OM_Matrix__lbl_ItemsCreated"));

        if (this.itemsToCreate.length > 0 || this.itemsToDelete.length > 0 || this.itemsToUpdate.length > 0 || this.notesDirty) {
            this.UiModder.domClass.remove(this.btnCommit, "w3-disabled");
            this.UiModder.domClass.remove(this.btnRollback, "w3-disabled");

            //this.btnCommit.setReadonly(false);
            //this.btnRollback.setReadonly(false);
        } else {
            //this.btnCommit.setReadonly(true);
            //this.btnRollback.setReadonly(true);
            this.UiModder.domClass.add(this.btnCommit, "w3-disabled");
            this.UiModder.domClass.add(this.btnRollback, "w3-disabled");
        }
    }

    ClearStack(): void {
        this.stack = new Array<StackEntry>();
        this.displayStack();
    }

    addToStack(entity: OrchestraMatrixWsy_DataItem_Content, action: "create" | "delete" | "update"): void {
        let entry = new StackEntry();
        entry.Entity = entity;
        entry.action = action;
        this.stack.push(entry)

        this.displayStack();
    }

    // Host meldet, ob gestagte Anmerkungs-Aenderungen vorliegen -> Buttons aktivieren/deaktivieren.
    setNotesDirty(dirty: boolean): void {
        this.notesDirty = dirty;
        this.displayStack();
    }

    _onClick_Rollback(): void {
        this.emit("rollback");
    }

    _onClick_Commit(): void {
        this.Commit();
    }

    _calculateStackEntityActions(): void {
        this.itemsToCreate = new Array<OrchestraMatrixWsy_DataItem_Content>();
        this.itemsToDelete = new Array<OrchestraMatrixWsy_DataItem_Content>();
        this.itemsToUpdate = new Array<OrchestraMatrixWsy_DataItem_Content>();

        for (let stackEntry of this.stack) {
            if (stackEntry.action == "create") {
                this.itemsToCreate.push(stackEntry.Entity);
            } else if (stackEntry.action == "delete") {
                if (stackEntry.Entity.ID != null) {
                    this.itemsToDelete.push(stackEntry.Entity);
                }

                let deletedIndexInCreateArray = this.itemsToCreate.indexOf(stackEntry.Entity);
                if (deletedIndexInCreateArray > -1) {
                    this.itemsToCreate.splice(deletedIndexInCreateArray, 1); // ungespeichertes item in create-liste das gelöscht werden soll oO
                }
            }
            else if (stackEntry.action == "update") {
                console.log("update", stackEntry);

                if (stackEntry.Entity.ID != null) {
                    let existingIndexInUpdateArray = this.itemsToUpdate.indexOf(stackEntry.Entity);
                    if (existingIndexInUpdateArray == -1) {
                        this.itemsToUpdate.push(stackEntry.Entity);
                    }
                } else {
                    let existingIndexInCreateeArray = this.itemsToCreate.indexOf(stackEntry.Entity);
                    if (existingIndexInCreateeArray == -1) {
                        this.itemsToCreate.push(stackEntry.Entity);
                    }
                }
            }
        }
    }

    Commit(): void {

        //  delete und create-Listen befüllen
        //
        this._calculateStackEntityActions();

        this.emit("beforeCommit", true);

        //  Nur Anmerkungen geaendert (kein Inhalt) -> keinen leeren CommitContent absetzen.
        //  Der Host speichert die Anmerkungen im commit-Handler separat (CommitRowNotes).
        if (this.itemsToCreate.length === 0 && this.itemsToDelete.length === 0 && this.itemsToUpdate.length === 0) {
            this.emit("commit", true);
            return;
        }

        //  gesamten Stack in einem Request verarbeiten
        //
        /*let url = window.appRoot + "data/CommitContent";
        this.RequestManager.post(url,
            {
                "JsonData": JSON.stringify({
                    "itemsToDelete": this.itemsToDelete,
                    "itemsToCreate": this.itemsToCreate
                })
            },
            lang.hitch(this, this.handleStack_Response),
            lang.hitch(this, this.handleStack_Error)
        );*/

        this.RequestManager.callfunction(
            "Webtool_API_MatrixView_WSY__CommitContent",
            {
                "itemsToDelete": this.itemsToDelete,
                "itemsToCreate": this.itemsToCreate,
                "itemsToUpdate": this.itemsToUpdate
            },
            lang.hitch(this, this.handleStack_Response),
            lang.hitch(this, this.handleStack_Error),
            false,
            { skipXssCheck: true }
        );
    }

    handleStack_Response(response: any): void {
        this.emit("commit", true);
    }

    handleStack_Error(error: any): void {
        // Server-Detail für Entwickler in die Konsole (Toast bleibt für den User generisch)
        console.error("Webtool_API_MatrixView_WSY__CommitContent failed", error);

        // Commit-Fehler war bisher stumm -> Toast, damit der User sieht dass NICHT gespeichert wurde
        this.showToast({
            title: this.getTranslation("OM_Matrix__CommitError"),
            iconClass: "fas fa-times-circle w3-text-red",
            timeout: "permanent"
        });

        this.emit("commit", false);
    }


    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(SelectionStateManagerV2);